// Router shim: same API as react-router-dom, but internal links keep the current language prefix.
import React, { forwardRef, useCallback } from "react";
import { Link as RLink, NavLink as RNavLink, Navigate as RNavigate, useNavigate as rUseNavigate } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { localizeTo } from "@/lib/i18nPath";

export * from "react-router-dom";

export const Link = forwardRef(({ to, ...rest }, ref) => {
  const { lang } = useLang();
  return <RLink ref={ref} to={localizeTo(to, lang)} {...rest} />;
});

export const NavLink = forwardRef(({ to, ...rest }, ref) => {
  const { lang } = useLang();
  return <RNavLink ref={ref} to={localizeTo(to, lang)} {...rest} />;
});

export const Navigate = ({ to, ...rest }) => {
  const { lang } = useLang();
  return <RNavigate to={localizeTo(to, lang)} {...rest} />;
};

export const useNavigate = () => {
  const nav = rUseNavigate();
  const { lang } = useLang();
  return useCallback((to, opts) => (typeof to === "number" ? nav(to) : nav(localizeTo(to, lang), opts)), [nav, lang]);
};
